import { Card, Empty, Form, Input, Select, notification } from "antd";
import { get } from "lodash";
import { useNavigate, useParams } from "react-router-dom";
import { BiChevronLeft } from "react-icons/bi";
import Header from "shared/components/Header";
import { useMutation, useQuery } from "shared/hooks/useApi";
import graphql from "utils/api/graphql";
import { SCREENS } from "utils/constants";
import SequenceBuilder from "../../Campaigns/Detail/SequenceBuilder";

const CATEGORY_OPTIONS = [
  { value: "cold_outreach", label: "Prospection à froid" },
  { value: "re_engagement", label: "Ré-engagement" },
  { value: "event_followup", label: "Suivi événement" },
  { value: "inbound_nurture", label: "Nurture entrant" },
  { value: "upsell", label: "Upsell" },
  { value: "custom", label: "Personnalisé" },
];

const Detail = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const { data, loading } = useQuery(graphql.queries.CRM_SEQUENCE_TEMPLATES, {
    variables: { where: { id } },
    fetchPolicy: "network-only",
  });

  const [updateTemplate] = useMutation(graphql.mutations.UPDATE_CRM_SEQUENCE_TEMPLATE);

  const templates = get(data, "crmSequenceTemplates.data") || [];
  const template = templates[0];

  if (loading) return "Chargement...";
  if (!template) return <Empty description="Modèle non trouvé" />;

  const saveField = async (field, value) => {
    try {
      await updateTemplate({
        variables: { where: { id }, data: { [field]: value } },
      });
    } catch (err) {
      notification.error({ message: "Échec de la mise à jour" });
    }
  };

  return (
    <>
      <Header
        key="header"
        title={template.name}
        actions={[{
          text: "Retour",
          onClick: () => navigate(SCREENS.PRIVATE.ADMIN.SEQUENCE_TEMPLATES.LIST.path),
          type: "primary--outlined",
          icon: <BiChevronLeft size={20} />,
        }]}
      />

      <Card title="Métadonnées" size="small" className="m-bottom-16">
        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          <div>
            <label style={{ fontSize: 12, color: "#6b7280", display: "block", marginBottom: 4 }}>Nom</label>
            <Input defaultValue={template.name} onBlur={(e) => saveField("name", e.target.value)} />
          </div>
          <div>
            <label style={{ fontSize: 12, color: "#6b7280", display: "block", marginBottom: 4 }}>Description</label>
            <Input.TextArea defaultValue={template.description} rows={2} onBlur={(e) => saveField("description", e.target.value)} />
          </div>
          <div>
            <label style={{ fontSize: 12, color: "#6b7280", display: "block", marginBottom: 4 }}>Catégorie</label>
            <Select
              defaultValue={template.category}
              style={{ width: 250 }}
              onChange={(val) => saveField("category", val)}
            >
              {CATEGORY_OPTIONS.map((c) => (
                <Select.Option key={c.value} value={c.value}>{c.label}</Select.Option>
              ))}
            </Select>
          </div>
        </div>
      </Card>

      <Card title="Séquence" size="small">
        <SequenceBuilder sequenceId={template.sequenceId} campaignState="draft" />
      </Card>
    </>
  );
};

export default Detail;
